import React, { useEffect, useState } from "react";
import { ChannelOrganizationModel, ChannelType, mapToChannelModel } from "../../../models/channels/channels.model";
import { ProviderService } from "../../../services/channels/ChannelProviderService";
import { ActionLabels, GridStatusLabelVariant, emptyLabels, pageTitles } from "../../shared/constants";
import PageHeaderComponent from "../../shared/page-header.component";
import { ColDef, ICellRendererParams, ValueGetterParams, ValueFormatterParams } from "ag-grid-community";
import { EditIcon, MessengerIcon } from "../../../icon";
import { UtilityService } from "../../../services/UtilityService";
import GridComponent from "../../shared/grid";
import { ActionsRenderer } from "../../shared/grid/actionsRenderer";
import { StatusRenderer } from "../../shared/grid/statusRenderer";
import { AvatarRenderer } from "../../shared/grid/avatarRenderer";
import FacebookIcon from "../../../icons/fb-big-cirlce-icon.svg";
import InstaIcon from "../../../icons/insta-big-circle-icon.svg";
import WhatsappIcon from "../../../icons/channel-whatsapp-icon.svg";
import GoogleBusinessIcon from "../../../icons/google-business-icon.svg";
import LiveChatIcon from "../../../icons/live-chat-icon.svg";
import { setHeaderTitle, setRefreshHandler } from "../../../helpers/header.helper";


const SystemAdminChannels = () => {

    const [channels, setChannels] = useState([])
    const [gridApi, setGridApi] = useState<any>(null)

    const OrgColoumnDefs: ColDef[] = [
        {
            field: "Label",
            headerName: "Channel",
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.Label}`
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                { console.log(params.data.Type) }

                const AvatarComponent = {
                    component: AvatarRenderer,
                    params: {
                        SetName: params.data.Label,
                        HideAvatar: false,
                        Icon: params.data.Type === ChannelType.FACEBOOK
                            ? FacebookIcon
                            : params.data.Type === ChannelType.INSTAGRAM
                                ? InstaIcon
                                : params.data.Type === ChannelType.LIVE_CHAT
                                    ? LiveChatIcon :
                                    params.data.Type === ChannelType.GOOGLE_BUSINESS ?
                                        GoogleBusinessIcon
                                        : params.data.Type === ChannelType.MESSENGER
                                            ? MessengerIcon : WhatsappIcon
                    }
                }
                if (params.data) {
                    return AvatarComponent
                }
                return undefined
            },
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            field: "status",
            headerName: "Status",
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.Status === 1 ? "Connected" : "Disconnected";
                    const variant = params.data.Status === 2 ? GridStatusLabelVariant.Danger : GridStatusLabelVariant.Active;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
            suppressSizeToFit: true,
            minWidth: 200,
            width: 200,
            maxWidth: 200,
        },
        {
            field: "UpdatedAt",
            headerName: "Updated Date",
            valueFormatter: (params: ValueFormatterParams) => {
                return UtilityService.convertDateToDay(params.value).toString()
            },
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data.UpdatedAt).toString()
            },
            minWidth: 150,
            width: 150,
            suppressSizeToFit: true
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params =>
                <ActionsRenderer
                    MenuData={getMenuActions(params.data)}
                    {...params}
                />,
            resizable: false,
            sortable: false,
        },
    ]

    const getMenuActions = (data: ChannelOrganizationModel) => {
        return [
            {
                Name: data.Status === 1 ? "Disable" : "Enable",
                Icon: EditIcon,
                OnClick: () => { updateChannel(data) },
            },
        ]
    }

    const updateChannel = (data) => {

        if (data.Status === 1) {
            ProviderService.disableChannel(data.Type).then(res => {
                getChannels()
            }).catch(() => {

            })
        }
        else {
            ProviderService.enabelChannel(data.Type).then(res => {
                getChannels()
            }).catch(() => {

            })
        }

    }


    const getChannels = () => {
        ProviderService.getChannels().then(res =>
            setChannels(res.data.map(x => mapToChannelModel(x)))
        )

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
            gridApi.deselectAll();
        }
    }

    useEffect(() => {
        getChannels()
        setHeaderTitle("SystemAdminChannels")
        setRefreshHandler(() => getChannels())
    }, [])


    const getGridTitle = () => {

        if (channels?.length === 1) {
            return "1 Organization"
        }
        else {
            return channels?.length + " " + pageTitles.CHANNELS
        }
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
    }

    const searchOrganizations = (e: any) => {
        gridApi?.setQuickFilter(e.target.value)
    }

    return (
        <div className="w-p-100 h-p-100">
            <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                <PageHeaderComponent
                    Reload={() => getChannels()}
                    PlaceHolder={"Search..."}
                    GridTitle={getGridTitle()}
                    Count={channels.length}
                    onSearch={searchOrganizations} />

                <GridComponent
                    ColumnDefs={OrgColoumnDefs}
                    RowData={channels}
                    OnGridReady={onGridReady}
                    IsPaginationEnabled={true}
                    EmptyLabel={emptyLabels.CHANNELS}
                    gridApi={gridApi}
                    LockVisible={false}
                />
            </div>
        </div>
    )
}

export default SystemAdminChannels;